module.exports = __webpack_public_path__ + "static/media/img_30.4544e9c0.JPG";